module.exports = __webpack_public_path__ + "static/media/medium.fc728fb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medium.svg
// module id = 224
// module chunks = 2